module.exports = __webpack_public_path__ + "static/img/2.535d460.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/2.png
// module id = OTl0
// module chunks = 0